import React from "react";
import { K } from "../theme";

// Optional `grad` — a CSS gradient string — overrides the solid `c` fill,
// used where the bar should echo the brand banner (navy → emerald) instead
// of a single status color.
export const Pr = ({ value, max = 100, c = K.p, h = 5, grad }) =>
  <div className="w-full overflow-hidden" style={{ height: h, background: `${c}10`, borderRadius: h }}>
    <div className="h-full" style={{ width: `${Math.min(value / max * 100, 100)}%`, background: grad || c, borderRadius: h }} />
  </div>;
